import { produce } from 'immer';
import { create } from 'zustand';

interface AdvancedTreeState {
  selectedRows: string[]; // list of selected rows
  selectRow: (selectedNodeId: string) => void;
  deSelectRow: (selectedNodeId: string) => void;
  removeAllSelectedRows: () => void;
  toggleSelectedRow: (selectedNodeId: string) => void;
}

export const ADVANCED_TREE_STORE = create<AdvancedTreeState>((set) => ({
  selectedRows: [],

  deSelectRow: (selectedNodeId) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        draft.selectedRows.filter((selectedRow) => selectedRow === selectedNodeId).pop();
      });

      return newState;
    }),

  selectRow: (selectedNodeId: string) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        !draft.selectedRows.includes(selectedNodeId) && draft.selectedRows.push(selectedNodeId);
      });

      return newState;
    }),
  removeAllSelectedRows: () =>
    set((state) => {
      if (state.selectedRows.length === 0) {
        return state;
      }

      return { selectedRows: [] };
    }),

  toggleSelectedRow: (selectedNodeId: string) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        const exists = draft.selectedRows.includes(selectedNodeId);

        if (exists) {
          draft.selectedRows = draft.selectedRows.filter((row) => row !== selectedNodeId);
        } else {
          draft.selectedRows.push(selectedNodeId);
        }
      });

      return newState;
    })
}));
